import {ValueObject} from '@s-ui/domain'
import {toQueryString} from '@s-ui/js/lib/string'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'

const isNotNumber = num => num === null || isNaN(num)

export class GetVehicleContentRequest extends ValueObject {
  #make
  #makeId
  #model
  #modelId

  static validate({makeId, modelId}) {
    if (isNotNumber(makeId) || isNotNumber(modelId)) {
      throw InvalidParamsSharedError.create(
        `[GetVehicleContentRequest.validate] param makeId and modelId are required and should be numbers`
      )
    }
  }

  constructor({makeId, modelId, make, model}) {
    super()
    this.#make = make
    this.#makeId = makeId
    this.#model = model
    this.#modelId = modelId
  }

  static create({make, makeId, model, modelId}) {
    GetVehicleContentRequest.validate({makeId, modelId})
    return new GetVehicleContentRequest({
      make,
      makeId,
      model,
      modelId
    })
  }

  get makeId() {
    return this.#makeId
  }

  get modelId() {
    return this.#modelId
  }

  get make() {
    return this.#make
  }

  get model() {
    return this.#model
  }

  get value() {
    return {
      make: this.#make,
      makeId: this.#makeId,
      model: this.#model,
      modelId: this.#modelId
    }
  }

  toQueryString() {
    return toQueryString({
      makeId: this.#makeId,
      modelId: this.#modelId,
      ...(this.#make && {make: this.#make}),
      ...(this.#model && {model: this.#model})
    })
  }
}
